import React from "react";

export default function BaseElement({
    input,
    label,
    helpertext,
    errortext,
    ...props
}) {
    if (props.variant && props.variant === "horizontal") {
        return (
            <div className="space-y-1 px-4 sm:space-y-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                <div>{label}</div>
                <div className="sm:col-span-2">
                    {input}
                    {props.appendElement ? props.appendElement : ""}
                    {helpertext}
                    {errortext}
                </div>
            </div>
        );
    }

    return (
        <div>
            {label}
            <div className="mt-1">{input}</div>
            {props.appendElement ? props.appendElement : ""}
            {helpertext}
            {errortext}
        </div>
    );
}
